/* eslint-disable import/no-default-export */
import { combineReducers } from 'redux';

import actions, { ActionsState } from './actions';
import announcements, { AnnouncementsState } from './announcements';
import boardStars, { BoardStarState } from './board-stars';
import boards, { BoardState } from './boards';
import cards, { CardState } from './cards';
import deployments, { DeploymentsState } from './deployments';
import enterprises, { EnterpriseState } from './enterprises';
import highlights, { HighlightsState } from './highlights';
import labels, { LabelState } from './labels';
import lists, { ListState } from './lists';
import members, { MemberState } from './members';
import notifications, { NotificationsState } from './notifications';
import plugins, { PluginsState } from './plugins';
import reactions, { ReactionState } from './reactions';
import savedSearches, { SavedSearchState } from './saved-searches';
import search, { SearchState } from './search';
import session, { SessionState } from './session';
import shortLinkMap, { ShortLinkMapState } from './shortLinkMap';
import teams, { TeamState } from './teams';
import upNext, { UpNextState } from './up-next';

export * from './actions';
export * from './announcements';
export * from './board-stars';
export * from './boards';
export * from './cards';
export * from './deployments';
export * from './enterprises';
export * from './highlights';
export * from './labels';
export * from './lists';
export * from './members';
export * from './notifications';
export * from './plugins';
export * from './reactions';
export * from './saved-searches';
export * from './search';
export * from './session';
export * from './shortLinkMap';
export * from './teams';
export * from './up-next';

export interface ModelState {
  actions: ActionsState;
  announcements: AnnouncementsState;
  boardStars: BoardStarState;
  boards: BoardState;
  cards: CardState;
  deployments: DeploymentsState;
  enterprises: EnterpriseState;
  highlights: HighlightsState;
  labels: LabelState;
  lists: ListState;
  members: MemberState;
  notifications: NotificationsState;
  plugins: PluginsState;
  reactions: ReactionState;
  savedSearches: SavedSearchState;
  search: SearchState;
  session: SessionState;
  shortLinkMap: ShortLinkMapState;
  teams: TeamState;
  upNext: UpNextState;
}

// @ts-ignore
export default combineReducers({
  actions,
  announcements,
  boardStars,
  boards,
  cards,
  deployments,
  enterprises,
  highlights,
  labels,
  lists,
  members,
  notifications,
  plugins,
  reactions,
  savedSearches,
  search,
  session,
  shortLinkMap,
  teams,
  upNext,
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/index.ts